import { render, staticRenderFns } from "./resource-single.vue?vue&type=template&id=77c6c3b8&scoped=true&"
import script from "./resource-single.ts?vue&type=script&lang=ts&"
export * from "./resource-single.ts?vue&type=script&lang=ts&"
import style0 from "./resource-single.scss?vue&type=style&index=0&id=77c6c3b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c6c3b8",
  null
  
)

export default component.exports